import { comma } from "../constants";

const td = { border: "1px solid #333", padding: "6px 10px", fontSize: 12 };
const th = { ...td, background: "#e5e7eb", fontWeight: 700, width: "28%" };

const fmtDateTime = (v) => {
  if (!v) return "—";
  return v.replace("T", " ");
};

const isSet = (v) => v !== null && v !== undefined;

export default function DeficitCasePrint({ caseData: c, onClose }) {
  if (!c) return null;

  return (
    <div
      className="slip-print-overlay"
      style={{
        position: "fixed", inset: 0, background: "#0009", zIndex: 2000,
        display: "flex", flexDirection: "column", alignItems: "center",
        overflowY: "auto", padding: "20px 0",
      }}
    >
      <style>{`
        .slip-print-page, .slip-print-page * { box-sizing: border-box; }
        @media print {
          .no-print { display: none !important; }
          html, body { margin: 0 !important; padding: 0 !important; }
          body * { visibility: hidden; }
          .slip-print-page, .slip-print-page * { visibility: visible; }
          .slip-print-page {
            position: absolute; inset: 0; margin: 0 !important;
            box-shadow: none !important;
            width: 100% !important; max-width: 100% !important; min-height: 0 !important;
          }
          @page { size: A4; margin: 12mm; }
        }
      `}</style>

      <div className="no-print" style={{ display: "flex", gap: 10, marginBottom: 14 }}>
        <button
          onClick={() => window.print()}
          style={{
            background: "#22c55e", color: "#fff", border: "none", borderRadius: 8,
            padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: "pointer",
          }}
        >
          🖨️ طباعة
        </button>
        <button
          onClick={onClose}
          style={{
            background: "#475569", color: "#fff", border: "none", borderRadius: 8,
            padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: "pointer",
          }}
        >
          إغلاق
        </button>
      </div>

      <div
        className="slip-print-page"
        style={{
          background: "#fff", color: "#111", width: "210mm", minHeight: "297mm",
          padding: "14mm", boxShadow: "0 0 24px #0006", fontFamily: "Arial, sans-serif",
          direction: "rtl",
        }}
      >
        <h2 style={{ textAlign: "center", margin: "0 0 4px", fontSize: 18 }}>
          تقرير حالة عجز الردود
        </h2>
        <p style={{ textAlign: "center", margin: "0 0 16px", fontSize: 13, color: "#444" }}>
          المحطة: <strong>{c.station_name}</strong> — الحالة:{" "}
          <strong>{c.status === "closed" ? "مغلقة" : "مفتوحة"}</strong>
        </p>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 14 }}>
          <tbody>
            <tr>
              <th style={th}>المحطة</th>
              <td style={td}>{c.station_name}</td>
              <th style={th}>المراجع</th>
              <td style={td}>{c.reviewer_name}</td>
            </tr>
            <tr>
              <th style={th}>مشرف المحطة</th>
              <td style={td}>{c.supervisor_name}</td>
              <th style={th}>جوال المشرف</th>
              <td style={td}>{c.supervisor_phone || "—"}</td>
            </tr>
            <tr>
              <th style={th}>تاريخ ووقت الرد</th>
              <td style={td}>{fmtDateTime(c.reply_datetime)}</td>
              <th style={th}>حمولة الرد</th>
              <td style={td}>{c.reply_load || "—"}</td>
            </tr>
            <tr>
              <th style={th}>قيمة الرد</th>
              <td style={td}>{c.reply_value ? `${comma(c.reply_value)} ر.س` : "—"}</td>
              <th style={th}>رقم الحالة</th>
              <td style={td}>#{c.id}</td>
            </tr>
            <tr>
              <th style={th}>تاريخ فتح الحالة</th>
              <td style={td}>{fmtDateTime(c.created_at)}</td>
              <th style={th}>آخر تحديث</th>
              <td style={td}>{fmtDateTime(c.updated_at)}</td>
            </tr>
          </tbody>
        </table>

        {c.notes && (
          <div style={{ marginBottom: 16 }}>
            <p style={{ fontSize: 12, fontWeight: 700, margin: "0 0 4px" }}>ملاحظات:</p>
            <div style={{ ...td, minHeight: 30, whiteSpace: "pre-wrap" }}>{c.notes}</div>
          </div>
        )}

        <p style={{ fontSize: 13, fontWeight: 700, margin: "0 0 8px" }}>
          الإجراءات المتخذة:
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
          <thead>
            <tr>
              <th style={{ ...th, width: "6%" }}>#</th>
              <th style={{ ...th, width: "26%" }}>الإجراء</th>
              <th style={th}>النتيجة</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ ...td, textAlign: "center" }}>1</td>
              <td style={td}>التحقق من صحة الرد</td>
              <td style={td}>
                {!isSet(c.validity_confirmed)
                  ? "لم يُنفَّذ بعد"
                  : c.validity_confirmed
                  ? "✔ الرد صحيح"
                  : `✘ الرد غير صحيح${c.validity_reason ? ` — ${c.validity_reason}` : ""}`}
              </td>
            </tr>
            <tr>
              <td style={{ ...td, textAlign: "center" }}>2</td>
              <td style={td}>التواصل مع المشرف ومشاركة الصور</td>
              <td style={td}>
                {!isSet(c.contact_done)
                  ? "لم يُنفَّذ بعد"
                  : c.contact_done
                  ? "✔ تم التواصل"
                  : "✘ لم يتم التواصل"}
              </td>
            </tr>
            <tr>
              <td style={{ ...td, textAlign: "center" }}>3</td>
              <td style={td}>رد المشرف</td>
              <td style={{ ...td, whiteSpace: "pre-wrap" }}>
                {c.supervisor_response || "لم يُدرج رد بعد"}
              </td>
            </tr>
            <tr>
              <td style={{ ...td, textAlign: "center" }}>4</td>
              <td style={td}>إعداد مذكرة بالواقعة</td>
              <td style={td}>
                {c.memo_number ? `تم — رقم المذكرة: ${c.memo_number}` : "لم تُعد بعد"}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 40 }}>
          <div style={{ textAlign: "center", width: "45%" }}>
            <div style={{ borderTop: "1px solid #333", paddingTop: 6, fontSize: 12 }}>
              توقيع المشرف المسؤول
            </div>
          </div>
          <div style={{ textAlign: "center", width: "45%" }}>
            <div style={{ borderTop: "1px solid #333", paddingTop: 6, fontSize: 12 }}>
              توقيع مدير النظام
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
